import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
// import {ItemsGroup} from "../../views/setting/usersGroups/usersGroups";
import {User} from "../../model";
import {UserService} from "../../services/user.service";
import {Message} from "primeng/api";
import {BranchService} from "../../views/setting/branches/branch.service";

@Component({
    selector: 'app-user-profile',
    templateUrl: './branches-list.component.html',
    styleUrls: ['./branches-list.component.scss'],
    providers: []
})
export class BranchesListComponent implements OnInit {
    id: string;
    //filter: any;
    public user: User;
    userData: any;
    public logs: Log[];

    msgs: Message[] = [];
    @Input() rowId;
    @Input() refRec: any;
    @Input() refShow;
    behalf:string;
    modalRef: NgbModalRef;
    form: FormGroup;
    sts:string;
    branch_id:any;
    public newBranch:any;
    public branches:any[]=[];

    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private userService: UserService,
                private branchesService:BranchService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;
            this.branch_id = userdata.branch_id;
        }
        this.userService.getById(userdata.id).subscribe(
            bra => {
                this.branches = bra.allbranch;
                var result = this.branches.reduce((unique, o) => {
                    if(!unique.some(obj => obj.label === o.label && obj.value === o.value)) {
                      unique.push(o);
                    }
                    return unique;
                },[]);
                this.branches = result;
            }
        );
    }


    ngOnInit() {
        this.userService.getById(this.refRec.creation_user).subscribe(
            user => {
                this.form.controls['last_update_user'].setValue('('+ user.last_update_user +') -- '+user.name);
            }
        );
        this.userService.getById(this.refRec.creation_user).subscribe(
            user => {
                this.form.controls['creation_user'].setValue(user.name);
            }
        );
        this.userService.getById(this.refRec.on_behalf_of).subscribe(
            user=>{
                this.form.controls['on_behalf'].setValue('('+ user.id +') -- '+user.name);
            }
        );
        this.userService.getById(this.refRec.last_on_behalf_of).subscribe(
            user=>{
                this.form.controls['last_on_behalf'].setValue('('+ user.id +') -- '+user.name);

            }
        );
    }

    switchBranch(id:any){
        const user = JSON.parse(localStorage.getItem('currentUser'));
        user.branch_id = id;
        localStorage.setItem('currentUser', JSON.stringify(user));

        this.branch_id = user.branch_id;
        this.close();
    }

    close() {
        this.activeModal.dismiss('done');
    }



}



// WEBPACK FOOTER //
// ./src/app/components/branches-list/branches-list.component.ts